/**************************************************
 * Nombre:       Seccion_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import fondo from '../../Recursos/fondo_secciones.svg'
import fondo_peq from '../../Recursos/fondo_secciones_peq.svg'
import Home_Oferta_Tiempo from "./Componentes/Home_Oferta_Tiempo";
import Testimonios from "./Componentes/Testimonios";
import Galleria from "./Componentes/Galleria";
import Home_Articulos from "./Componentes/Home_Articulos";
import {SECCIONES} from "../../Constantes";
import {useEffect, useState} from "react";
import Resultados_Lista from "./Componentes/Resultados_Lista";
import {useParams} from "react-router";
import {buscarPalabra} from "../../Modulo_Algolia/Funciones/buscarPalabra";
import {irArriba} from "../../Utilidades/irArriba";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";

const Seccion_Resultados = () => {
    const parms = useParams();
    const [palabra, setPalabra] = useState('');
    const [productos, setProductos] = useState([]);

    useEffect(() => {

        irArriba()
        if (parms && parms.tipo && parms.id) {
            setPalabra(parms.id);

            setProductos([])
            if (parms.tipo === 'Palabra') {
                buscarPalabra({palabra: parms.id, coleccion: 'productos'}).then((dox) => {
                    setProductos(dox)
                })
            } else {
                let w = [where('tipos', 'array-contains', parms.id)]
                obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                    setProductos(dox.data)
                })
            }


        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#EDFCF6'}}
        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: 1,
                    zIndex: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Resultados_Lista palabra={palabra} items={productos}/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Oferta_Tiempo/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo_peq})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: -4,
                    zIndex: 2
                }}
            >

                <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Testimonios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Galleria/>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Articulos/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Resultados